import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { mainLightGray } from "../styles"

const Intro = () => {
  const data = useStaticQuery(graphql`
    query {
      file(
        relativePath: { eq: "pt-assets/prime-trust-prime-ira-graphics.png" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  return (
    <Wrapper>
      <div className="container">
        <div className="row justify-content-center d-flex align-items-center">
          <div className="col-lg-6">
            <Img
              fluid={data.file.childImageSharp.fluid}
              alt="traditional ira or roth ira investing with prime ira"
            />
          </div>
          <div className="col-lg-5">
            {" "}
            <p>
              Self-directed IRAs offer a great way for investors to invest in
              start-up ventures, business expansions, and other ground floor
              opportunities. Historically, these types of investments were
              reserved exclusively for accredited investors or the
              ultra-wealthy.
            </p>
            <p>
              But thanks to Title lV of the Jobs Act, now anyone can acquire
              private stock and equity opportunities through Regulation A+. With
              new regulations in place, all investors have the opportunity to
              invest in startups, real estate, and private ventures with a
              Traditional IRA or a Roth IRA.
            </p>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background-color: ${mainLightGray};
  padding: 4rem 0;
  .col-lg-5,
  .col-lg-6 {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  img {
    max-width: 80%;
    max-height: 80%;
  }
`

export default Intro
